import CoachMembershipBanner from './coach-membership-banner'

export {
  MEMBERSHIP_BANNER_IDS,
  MEMBERSHIP_BANNER_LOGO_SRC,
  getCoachMembershipBannerCopy,
  resolveBannerLogoSrc,
} from './coach-membership-banner'
export default CoachMembershipBanner
